import * as hadate from '@ha/date';

const hasBookableWindow = ({ from, to }) => hadate.diffDay(to, from) >= 0;

export { hasBookableWindow };
